import { CSSProperties } from 'react';

import { userInfo } from 'features/user/config/defaults';

import Box from 'shared/components/Box/Box';
import Typography from 'shared/components/Typography/Typography';

type UserSubtitleProps = {
  children: React.ReactNode;
  maxWidth?: CSSProperties['maxWidth'];
};

export const UserSubtitle = ({
  children,
  maxWidth = userInfo.maxWidth,
}: UserSubtitleProps) => (
  <Box style={{ maxWidth }}>
    <Typography
      color="gray"
      fontWeight="regular"
      type="small"
      cropped={true}
      dataTestid="participant-info-email"
    >
      {children}
    </Typography>
  </Box>
);
